import Vue from 'vue';
//helper
import Account from '@/helper/AccountHelper.js';
import CacheHelper from "@/helper/CacheHelper.js";
import Locale from '@/helper/locale/Locale.js';
// import Util from '@/helper/Utility.js';
//core
import { CallbackEvent } from '@/core/Utility/CallbackEvent.js';
//config
import { RedeemConfigBuilder } from '@/core/Redeem/config/RedeemConfigBuilder.js';
//model
import { AddCartModel } from '@/core/Cart/model/CartModel.js';
//service
import BzbsCart from '@/core/Cart/service/BzbsCart.js';
import BzbsRedeem from '@/core/Redeem/service/BzbsRedeem.js';
import { DrawDeliveryModel } from '@/core/Redeem/model/DrawDeliveryModel.js';
import { SerialModel } from '@/core/Redeem/model/SerialModel.js';
import ConfigManager from '@/config/ConfigManager.js';
// import { ModalController } from '../../../components/Modal/ModalController';

/**
 * event
 * @method onRedeemSuccess
 * @method onErrorApi
 * @method onRedirect
 */
export function RedeemController () {
    this.lbl = Locale.getLbl();
    this.localeCode = Locale.getLocaleCode();
    this.cacheHelper = new CacheHelper();

    this.campaign = {};
    this.selectedCampaignId = null;
    this.selectedQuantity = null;

    this.redeemConfigBuilder = new RedeemConfigBuilder();
    this.modalController = null;

    this.cbRedeemSuccess = new CallbackEvent();
    this.cbRedirect = new CallbackEvent();
    this.cbApiError = new CallbackEvent();

    //#region initial
    /**
     * @param {CampaignModel} campaign /core/Campaign/model/CampaignModel.js
     * @param {ModalController} modalController /components/Modal/ModalController.js
     */
    this.initial = (campaign, modalController) => {
        this.campaign = campaign;
        this.modalController = modalController;
    };
    /**
     * @param {CampaignModel} campaign /core/Campaign/model/CampaignModel.js
     */
    this.reinitial = (campaign) => {
        this.lbl = Locale.getLbl();
        this.campaign = campaign;
    }
    //#endregion initial

    //#region redeem
    /**
     * @param {Number} selectedCampaignId campaign id
     * @param {Number} selectedQuantity quanty
     */
    this.clickRedeem = (selectedCampaignId, selectedQuantity) => {
        this.selectedCampaignId = selectedCampaignId;
        this.selectedQuantity = selectedQuantity;

        this.modalController.confirmRedeemModal
                            .clearModal()
                            .setCampaign(this.campaign)
                            .show()

        this.modalController.confirmRedeemModal.onClickConfirm(() => {
            // event confirm redeem
            this.confirmRedeem();
        });

        this.modalController.confirmRedeemModal.onClickCancel(() => {
            // event cancel redeem
        });
    };
    this.confirmRedeem = () => {
        if (this.campaign.type == Vue.CampaignType.Interface) {
            switch (this.campaign.interfaceDisplay) {
                case 'web':
                    this.openWebInterface();
                    break;
                case 'survey':
                case 'surveyapprove':
                    //TODO: Setup link
                    var surveyUrl = this.campaign.website;
                    this.eventRedirect({ type: 'web', link: surveyUrl })
                    break;
                case 'api':
                    this.eventRedirect();
                    break;
            }
        } else if (this.campaign.type == Vue.CampaignType.Buy) {
            this.addToCart();
        } else if (this.campaign.delivered) {
            this.modalController.shippingModal
                .clearModal()
                .setTitle(this.lbl.shipping.detail_headline)
                .setTag('detail')
                .setPage('detail')
                .show();

            this.modalController.shippingModal
                .onSelected(address => {
                    this.redeem(address);
                });
        } else {
            this.redeem();
        }
    };
    this.redeem = () => {
        this.modalController.loadingModal.show();

        var token = Account.getToken();
        var params = this.redeemConfigBuilder.getRedeemParams();
        BzbsRedeem.apiRedeemCampaign(token, this.selectedCampaignId, params, this.selectedQuantity)
            .subscribe((campaign) => {
                this.campaign.updateAfterRedeem(campaign);

                this.initialSerial();
                this.eventRedeemSuccess(campaign);
                this.modalController.loadingModal.hide();
            }, (err) => {
                this.eventErrorApi(err);
                this.modalController.loadingModal.hide();
            });
    };

    //#endregion redeem

    //#region interface redeem open web
    this.openWebInterface = function() {
        //TODO: Setup link
        var webUrl = this.campaign.website;
        var isShowHeader = 'false';
        var theme = ConfigManager.getAppName();
        var suffledToken = Account.getTokenShuffle();

        if (webUrl.indexOf('/Topup/InterfaceLanding') >= 0) {
            this.cacheHelper.setCache('isfromlanding', 'interface');
        } else if (webUrl.indexOf('wondd') >= 0) {
            this.cacheHelper.setCache('isfromlanding', 'wodd');
        } else {
            this.cacheHelper.setCache('isfromlanding', 'other');
        }

        webUrl += '&token=' + suffledToken
                + '&locale=' + this.localeCode
                + '&header=' + isShowHeader
                + '&theme=' + theme
                + '&return_url=' + encodeURIComponent(window.location.href);

        window.location.href = webUrl;
    };
    //#endregion interface redeem open web

    //#region buy
    this.addToCart = () => {
        if (this.showLoading) return;

        var token = Account.getToken();
        var cartItem = new AddCartModel();
        var cartParams = cartItem.addItem(this.selectedCampaignId, this.selectedQuantity)
                            .getParams();

        BzbsCart.apiAddToCart(token, cartParams).subscribe((data) => {
            console.log(data);
            this.hideLoading();
        }, (err) => {
            this.hideLoading();
            this.eventErrorApi(err);
        });
    };
    //#endregion buy
    //#region serial
    this.initialSerial = () => {
        if (this.campaign.delivered
            || this.campaign.type == Vue.CampaignType.Draw) {
            var drawDelivery = new DrawDeliveryModel();
            console.log(drawDelivery);
            drawDelivery.setModelFromDataModel(this.campaign);
            this.modalController.drawDeliveryModal
                .setDrawDelivery(drawDelivery)
                .setTag('detail')
                .show();
        } else {
            var serial = new SerialModel();
            serial.setModelFromDataModel(this.campaign);
            this.modalController.serialModal
                .setSerial(serial)
                .setTag('detail')
                .show();

            this.modalController.serialModal
                .onClickAction(data => {
                    if (data) {
                        switch(data.action) {
                            case 'history':
                                this.cbRedeemSuccess.sendCallback({page: '/history/burn'});
                                break;
                        }
                    }
                });

            this.modalController.serialModal
                .onClickClose(data => {
                    console.log(data);
                });
        }
    };
    //#endregion serial

    //#region loading
    this.showLoading = function () {
        if (this.isLoading) return true;
        this.isLoading = true;

        this.modalController.loadingModal.show();
    };
    this.hideLoading = function () {
        this.isLoading = false;
        this.modalController.loadingModal.hide();
    };
    //#endregion loading

    //#region event
    // redeem success
    this.onRedeemSuccess = function(callback) {
        this.cbRedeemSuccess.onCallback(callback);
    };
    this.eventRedeemSuccess = function(info) {
        this.cbRedeemSuccess.sendCallback(info);
    };

    //error api
    this.onErrorApi = function(callback) {
        this.cbApiError.onCallback(callback);
    };
    this.eventErrorApi = function(info) {
        this.cbApiError.sendCallback(info);
    };

    //redirect
    this.onRedirect = function(callback) {
        this.cbRedirect.onCallback(callback);
    };
    this.eventRedirect = function(info) {
        this.cbRedirect.sendCallback(info);
    };
    //#endregion event
}
